<template>
  <div class="stbox">
    <div class="top frw fac box-sizing" v-if="has_data">
      <span class="top_all frw fac fjb">
        <div class="top_bg frw fac">Current time：{{utime}}
          <span class="server_expiration">Server expiration time: <span class="font_da">15th</span> of every
            month</span>
        </div>
        <div class="frw fac">
          <el-form :inline="true" :model="params" class="user-search">
            <el-form-item label="">
              <el-cascader :options="country_business"
                :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
                placeholder="Country/Business" @change="cascaderChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="">
              <el-date-picker v-model="params.time" type="daterange" size="small" value-format="yyyy-MM-dd"
                align="right" unlink-panels start-placeholder="Start date" end-placeholder="End date"
                :picker-options="pickerOptions" clearable style="position:relative;top: -2px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size=" small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </span>
    </div>
    <div class="content fcl fjc" v-if="has_data">
      <div class="content_c frw fjb fw box-sizing">
        <div class="content_citem fcl" :style="{width:(screenWidth/2.6)+'px'}">
          <span class="home_title frw fac fjc">Recharge</span>
          <div class="c_top frw fac">
            <div class="c_top1 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Orders amount</span>
                <span class="c_top22">{{order_reserved.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Recharge amount</span>
                <span class="c_top22">{{message_success_reserved.sum_amount||0}}</span>
                <span class="c_top22"
                  v-if="message_success_reserved_usd.count>0">{{message_success_reserved_usd.sum_amount||0}}(USD)</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Orders nums</span>
                <span class="c_top22">{{order_reserved.count}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Recharge nums</span>
                <span class="c_top22">{{message_success_reserved.count}}</span>
                <span class="c_top22"
                  v-if="message_success_reserved_usd.count>0">{{message_success_reserved_usd.count}}(USD)</span>
              </div>
            </div>
            <div class="c_top_r f1 fcl fac fjc">
              <span class="c_top_r1">Recharge success rate</span>
              <span class="c_top_r2">{{dataDivide(message_success_reserved.count,order_reserved.count)}}%</span>
            </div>
          </div>
          <div class="c_bot frw fab fjc">
            <span class="c_bot1">Recharge fees</span>
            <span
              class="c_bot2">{{message_reserved.sum_fee||0}}({{dataDivide(message_reserved.sum_fee,message_reserved.sum_amount)}}%)</span>
            <span class="c_bot1">Callback success rate</span>
            <span class="c_bot2">{{dataDivide(message_success_reserved.count,message_reserved.count)}}%</span>
          </div>
        </div>
        <div class="content_citem fcl" :style="{width:(screenWidth/2.6)+'px'}">
          <span class="home_title frw fac fjc">Withdraw</span>
          <div class="c_top frw fac">
            <div class="c_top1 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Orders amount</span>
                <span class="c_top22">{{order_transaction.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Withdraw amount</span>
                <span class="c_top22">{{message_success_transaction.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Orders nums</span>
                <span class="c_top22">{{order_transaction.count}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Withdraw nums</span>
                <span class="c_top22">{{message_success_transaction.count}}</span>
              </div>
            </div>
            <div class="c_top_r f1 fcl fac fjc">
              <span class="c_top_r1">Withdraw success rate</span>
              <span class="c_top_r2">{{dataDivide(message_success_transaction.count,order_transaction.count)}}%</span>
            </div>
          </div>
          <div class="c_bot frw fab fjc">
            <span class="c_bot1">Withdraw fees</span>
            <span
              class="c_bot2">{{message_transaction.sum_fee||0}}({{dataDivide(message_transaction.sum_fee,message_transaction.sum_amount)}}%)</span>
            <span class="c_bot1">Callback success rate</span>
            <span class="c_bot2">{{dataDivide(message_success_transaction.count,message_transaction.count)}}%</span>
          </div>
        </div>
        <div class="content_citem fcl" :style="{width:(screenWidth/2.6)+'px'}">
          <span class="home_title title1 frw fac fjc">Recharge refund</span>
          <div class="c_top frw fac">
            <div class="c_top1 c_top100 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund amount</span>
                <span class="c_top22">{{refund_reserved.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund nums</span>
                <span class="c_top22">{{refund_reserved.count}}</span>
              </div>
            </div>
          </div>
          <div class="c_top frw fac">
            <div class="c_top1 c_top100 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund success amount</span>
                <span class="c_top22">{{refund_success_reserved.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund success nums</span>
                <span class="c_top22">{{refund_success_reserved.count}}</span>
              </div>
            </div>
          </div>
          <div class="c_bot frw fab fjc">
            <span class="c_bot1">Refund rate</span>
            <span class="c_bot2">({{dataDivide(refund_reserved.count,message_reserved.count)}}%)</span>
            <span class="c_bot1">Callback success rate</span>
            <span class="c_bot2">{{dataDivide(refund_success_reserved.count,refund_reserved.count)}}%</span>
          </div>
        </div>
        <div class="content_citem fcl" :style="{width:(screenWidth/2.6)+'px'}">
          <span class="home_title title1 frw fac fjc">Withdraw refund</span>
          <div class="c_top frw fac">
            <div class="c_top1 c_top100 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund amount</span>
                <span class="c_top22">{{refund_transaction.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund nums</span>
                <span class="c_top22">{{refund_transaction.count}}</span>
              </div>
            </div>
          </div>
          <div class="c_top frw fac">
            <div class="c_top1 c_top100 frw fw">
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund success amount</span>
                <span class="c_top22">{{refund_success_transaction.sum_amount||0}}</span>
              </div>
              <div class="c_top2 fcl fac">
                <span class="c_top21">Refund success nums</span>
                <span class="c_top22">{{refund_success_transaction.count}}</span>
              </div>
            </div>
          </div>
          <div class="c_bot frw fab fjc">
            <span class="c_bot1">Refund rate</span>
            <span class="c_bot2">({{dataDivide(refund_transaction.count,message_transaction.count)}}%)</span>
            <span class="c_bot1">Callback success rate</span>
            <span class="c_bot2">{{dataDivide(refund_success_transaction.count,refund_transaction.count)}}%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content frw box-sizing" v-if="has_data" style="padding-bottom:15px;">
      <div class="content_s1 fcl">
        <div class="content_top frw fac">
          <span>Business statistics</span>
        </div>
        <div class="content_c content_cb frw fjb fw box-sizing">
          <template>
            <el-table :data="infos.business_statics" style="width: 100%">
              <el-table-column prop="business_name" label="name" align="center" width="180">
              </el-table-column>
              <el-table-column prop="business_country" label="country" align="center" width="120">
              </el-table-column>
              <el-table-column prop="dlock_count" label="To be paid" width="100" align="center">
              </el-table-column>
              <el-table-column prop="lock_count" label="Locked" width="100" align="center">
              </el-table-column>
              <el-table-column prop="confirm_count" label="Confirmed" width="100" align="center">
              </el-table-column>
              <el-table-column prop="exceptional_count" label="Exceptional" width="120" align="center">
              </el-table-column>
              <el-table-column prop="reserved_num" label="Recharge nums" min-width="140" align="center">
              </el-table-column>
              <el-table-column prop="reserved_amount" label="Recharge amount" min-width="160" align="center">
              </el-table-column>
              <el-table-column prop="transaction_num" label="Withdraw nums" min-width="140" align="center">
              </el-table-column>
              <el-table-column prop="transaction_amount" label="Withdraw amount" min-width="160" align="center">
              </el-table-column>
              <el-table-column prop="total_amout" label="Pending payout principal" min-width="220" align="center">
              </el-table-column>
              <el-table-column prop="ledger_balance" label="Ledger balance" min-width="180" align="center">
              </el-table-column>
              <el-table-column prop="pending_debit" label="Payout reserved balance" min-width="220" align="center">
              </el-table-column>
              <el-table-column prop="available_balance" label="Available payout balance" min-width="220" align="center">
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {
    statistics,
    statisInfos,
    getCountryBusiness
  } from '../../api/apiFun'
  import {
    getCookie,
    timestampToTime,
    currentDate,
    cascaderChange,
  } from '@/utils/util'
  import {
    math
  } from '@/utils/math'
  export default {
    data() {
      return {
        group_name: getCookie('group_name'),
        value: [],
        params: {
          country: '',
          business: '',
          time: [currentDate(), currentDate()]
        },
        has_data: true,
        message_reserved: {},
        message_success_reserved: {},
        message_success_reserved_usd: {},
        message_success_transaction: {},
        message_transaction: {},
        order_reserved: {},
        order_transaction: {},
        refund_reserved: {},
        refund_success_reserved: {},
        refund_success_transaction: {},
        refund_transaction: {},
        infos: {},
        user: '',
        utime: '',
        robss: [],
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        country_business: [],
        screenWidth: 0
      }
    },
    mounted() {
      window.screenWidth = document.body.clientWidth;
      this.screenWidth = window.screenWidth;
    },
    created() {
      this.user = getCookie('dkh_user');
      this.getCountryBusiness()
      this.getStatisInfos(this.params)
      this.getStatistics(this.params)
    },
    methods: {
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business = cascader[1]
      },
      dataDivide(a, b) {
        if (!b) {
          return 0
        } else {
          var d = math.divide(a, b).toFixed(4)
          return math.multiply(d, 100);
        }

      },
      // Search事件
      search() {
        this.getStatistics(this.params)
        this.getStatisInfos(this.params)
      },
      getStatisInfos(parameter) {
        if (parameter.time == null) {
          parameter.time = ''
        }
        statisInfos(parameter).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.infos = res.datas
            this.has_data = true;
            var time = res.datas.time - 1
            setInterval(() => {
              time += 1;
              this.utime = this.timestampToTime(time)
            }, 1000);

          }
        }).catch(err => {
          this.$message.error('Failed to fetch additional information, please try again later!')
        })
      },
      timestampToTime(timestamp) {
        return timestampToTime(timestamp)
      },
      getStatistics(parameter) {
        if (parameter.time == null) {
          parameter.time = ''
        }
        statistics(parameter).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.message_reserved = res.datas.message_reserved
            this.message_success_reserved = res.datas.message_success_reserved
            this.message_success_reserved_usd = res.datas.message_success_reserved_usd
            this.message_success_transaction = res.datas.message_success_transaction
            this.message_transaction = res.datas.message_transaction
            this.order_reserved = res.datas.order_reserved
            this.order_transaction = res.datas.order_transaction
            this.refund_reserved = res.datas.refund_reserved
            this.refund_success_reserved = res.datas.refund_success_reserved
            this.refund_success_transaction = res.datas.refund_success_transaction
            this.refund_transaction = res.datas.refund_transaction
          }
        }).catch(err => {
          this.$message.error('Failed to get orders information, please try again later!')
        })
      },

    }
  };

</script>
<style scoped>
  @import url('./index.css');

</style>



// WEBPACK FOOTER //
// src/views/home/index.vue